<template>
    <div class="scanner-wrapper">
        <div class="scanner-header">
            <div class="scanner-brand">
                <img src="@/assets/images/icon.png">
                <div class="scanner-title">
                    TICKET SALLER
                </div>
            </div>

            <div class="btn-container">
                <button v-if="$getLoggedUser() && $getLoggedUser().user.profile_image" ref="settings-menu"
                    class="nav-button profile-btn" @click="show_settings_menu = true">
                    <img class="profile-logo" :src="$store.state.ASSETS_BASE_URL +
                        'assets/uploaded/' +
                        $getLoggedUser().user.profile_image
                        " />
                </button>
                <button v-else class="nav-button profile-btn" ref="settings-menu"
                    @click="show_settings_menu = !show_settings_menu">
                    <div class="empty-profile" v-if="$getLoggedUser()">
                        {{
                            $nameInitials(
                                $getLoggedUser().user.first_name +
                                " " +
                                $getLoggedUser().user.last_name
                            )
                        }}
                    </div>
                </button>
                <div class="settings-drop-down" v-if="$getLoggedUser() && show_settings_menu" v-closable="{
                    exclude: ['settings-menu'],
                    handler: 'hideSettingsMenu',
                }">
                    <div class="profile-widget">
                        {{
                            $getLoggedUser().user.first_name +
                            " " +
                            $getLoggedUser().user.last_name
                        }}
                    </div>
                    <!-- <div class="setting-item">
                <span class="fa fa-user icon"></span> <span>Profile</span>
              </div> -->
                    <div class="setting-item" @click="logOut()">
                        <span class="fa fa-lock icon"></span> <span>Logout</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!ticketScanned" class="scanner-body">
            <div class="search-widget">
                <b-field message="Search ticket or Scann Qr code below">
                    <b-input v-model="decodedString" placeholder="Enter token..." type="search" icon="magnify" expanded>
                    </b-input>
                    <p class="control">
                        <b-button @click="onSearch()" type="is-primary" label="Search" />
                    </p>
                </b-field>
            </div>
            <qrcode-stream @decode="onDecode" class="qr-camera"></qrcode-stream>
            <div class="scanning-frame"></div>
        </div>
        <div v-else class="scanner-body">
            <loading :height="100" color="#000" :opacity="1" :width="100" :active.sync="is_loading"
                :is-full-page="false" :can-cancel="false" background-color="#fff"></loading>
            <div v-if="ticketDetails && canScann" class="ticket-details">
                <div class="qr-widget">
                    <div class="qr-code-container">
                        <widgetQrCodePreview :value="ticketDetails.ticketToken" />
                    </div>
                </div>
                <div class="identifyer-widget">
                    {{ ticketDetails.bill_to_first_name }} {{ ticketDetails.bill_to_last_name }}
                    {{ ticketDetails.bill_to_phone ? `(${ticketDetails.bill_to_phone})` : `` }}
                </div>
                <div class="identifyer-widget">
                    <b-tag v-if="ticketDetails.payment_status == 'payed'" type="is-success">
                        ALREADY ACTIVATED
                    </b-tag>
                    <b-tag v-else type="is-warning">
                        NOT ACTIVATED
                    </b-tag>
                </div>
                <div class="seat-type-widget">
                    <h1>{{ ticketDetails.seatType }}</h1>
                </div>
                <div class="ticket-options">
                    <b-button v-if="ticketDetails.payment_status == 'payed'" :loading="loadingApproving"
                        @click="continueScanning()" type="is-default">CONTINUE
                        SCANNING</b-button>
                    <b-button v-else :loading="loadingApproving" @click="activateTicket()"
                        type="is-primary">ACTIVATE</b-button>
                </div>
            </div>

            <div v-else class="ticket-details">
                <div class="not-found">
                    <img src="@/assets/images/icons/info.svg">
                    <b-tag type="is-danger" size="is-large">
                        TICKET NOT FOUND
                    </b-tag>
                    <p>
                        {{ scannReson }}
                    </p>
                </div>
                <div class="ticket-options">
                    <b-button :loading="loadingApproving" @click="continueScanning()" type="is-default">CONTINUE
                        SCANNING</b-button>
                </div>
            </div>

        </div>
        <div class="scanner-footer">
        </div>
    </div>
</template>
<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
export default {
    name: "scanner-app",
    components: {
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture,
    },
    data() {
        return {
            decodedString: '',
            is_loading: false,
            ticketScanned: false,
            ticketDetails: null,
            loadingApproving: false,
            show_settings_menu: false,
            canScann: true,
            scannReson: ""
        };
    },
    mounted() {
        let vm = this;
        if (!vm.$getLoggedUser()) {
            vm.$router.push({ name: "login" });
        } else {
            if (vm.$getLoggedUser().user.account_type != "ticket_seller") {
                vm.logOut();
                vm.$router.push({ name: "login" });
            }
        }
    },
    computed: {
    },
    methods: {
        hideSettingsMenu() {
            let vm = this;
            vm.show_settings_menu = false;
        },
        onSearch() {
            let vm = this;
            vm.onDecode(vm.decodedString);
        },
        continueScanning() {
            let vm = this;
            vm.decodedString = "";
            vm.ticketScanned = false;
        },
        activateTicket() {
            let vm = this;
            vm.loadingApproving = true;
            vm.$store
                .dispatch("EVENTS_ACTIVATE_TICKET", {
                    id: vm.ticketDetails.id,
                    transationId: vm.ticketDetails.transationId,
                })
                .then((response) => {
                    vm.loadingApproving = false;
                    vm.decodedString = "";
                    vm.ticketScanned = false;
                    vm.$notify({
                        group: "status",
                        type: "success",
                        title: "Important message",
                        text: response.data.message,
                    });

                })
                .catch((error) => {
                    vm.loadingApproving = false;
                    vm.$notify({
                        group: "status",
                        type: "warn",
                        title: "Important message",
                        text: "Something went wrong",
                    });
                });
        },
        onDecode(decodedString) {
            let vm = this;
            if (!vm.ticketScanned) {
                vm.decodedString = decodedString;
                vm.is_loading = true;
                vm.ticketScanned = true;
                vm.$store
                    .dispatch("EVENTS_GET_TICKET_DETAILS", {
                        scannedToken: decodedString
                    })
                    .then((response) => {
                        vm.is_loading = false;
                        vm.canScann = true;
                        vm.scannReson = response.data.message;
                        vm.ticketDetails = response.data.return;
                    })
                    .catch((error) => {
                        vm.is_loading = false;
                        vm.canScann = false;
                        vm.scannReson = error.response.data.message;
                        console.error(error);
                    });
            }

        },
        logOut() {
            let vm = this;
            vm.$localStorage.remove("user_data");
            vm.$localStorage.remove("permission_list");
            vm.$router.push({ name: "login" });
        },
    },
};
</script>
<style lang="scss">
.scanner-wrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    .scanner-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        padding: 15px 20px;
        border-bottom: 1px solid #ccc;


        .scanner-brand {
            display: flex;
            align-items: center;

            img {
                width: 50px;
                object-fit: contain;
                margin-right: 10px;
            }

            .scanner-title {}
        }



        .btn-container {
            position: relative;
            margin-left: 10px;
            display: flex;
            align-items: center;

            .not-number {
                position: absolute;
                top: -10px;
                right: 0px;
                background: #01a2a7;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                height: 20px;
                width: 20px;
                border-radius: 50%;
            }

            .nav-button {
                background: transparent;
                border: none;
                display: flex;
                align-items: center;

                &.profile-btn {
                    position: relative;
                    top: -1px;
                }

                img.profile-logo {
                    height: 30px;
                    width: 30px;
                    border: 3px solid var(--wecodefy-secondary-color, #9fc953);
                    object-fit: cover;
                    border-radius: 50%;
                }

                .empty-profile {
                    height: 30px;
                    width: 30px;
                    border: 3px solid var(--wecodefy-secondary-color, #9fc953);
                    font-size: 11px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: -5px;
                    background: #000;
                    color: #fff;
                }
            }

            .settings-drop-down {
                position: absolute;
                top: 28px;
                right: 8px;
                width: 200px;
                z-index: 9999;
                background: #fff;
                border-radius: 5px;
                border: 1px solid #ddd;

                .profile-widget {
                    padding: 20px;
                    text-align: center;
                }

                .setting-item {
                    padding: 10px 13px;
                    font-size: 13px;
                    cursor: pointer;
                    border-bottom: 1px solid #ddd;

                    .icon {
                        margin-right: 10px;
                    }

                    &:hover {
                        background: #ddd;
                    }
                }
            }
        }
    }

    .scanner-body {
        height: calc(100% - 60px);
        width: 100%;
        padding: 20px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .search-widget {
            height: 80px;
            width: 100%;
        }

        .qr-camera {
            height: calc(100% - 80px);
            border-radius: 10px;
            overflow: hidden;
        }

        .scanning-frame {
            width: 300px;
            height: 300px;
            border: 4px solid rgb(9, 230, 9);
            position: absolute;
            z-index: 999;
            border-radius: 8px;
        }

        .ticket-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            .seat-type-widget {
                margin-top: 20px;

                h1 {
                    font-size: 30px;
                }
            }

            .qr-widget {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                overflow: hidden;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: center;

                .qr-code-container {
                    width: 150px;
                    height: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .ticket-options {
                margin-top: 40px;
            }

            .not-found {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;

                img {
                    width: 200px;
                    height: 200px;
                    object-fit: contain;
                    margin-bottom: 20px;
                }

                p {
                    margin-top: 20px;
                    font-size: 13px;
                    color: #828282;
                }
            }
        }
    }

    .scanner-footer {
        height: 00px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

}
</style>